import ResizableModal from '../../../../../ui/ResizableModal'
import { Button } from '../../../../../ui'
import InventoryItemFormFields from './InventoryItemFormFields'

const CreateItemModal = ({ actions, open, state }) => (
  <ResizableModal
    className='font-sans'
    open={open}
    onClose={actions.handleCloseCreateItemModal}
    width={820}
    height={760}
    minWidth={680}
    minHeight={560}
    footer={
      <>
        <Button
          onClick={actions.handleCloseCreateItemModal}
          className='rounded-full bg-primary text-sm uppercase text-white'
          title='CERRAR'
          disabled={actions.createItemMutation.isPending}
        />
        <Button
          type='submit'
          form='inventory-create-item-form'
          className='rounded-full bg-accent2 text-sm uppercase text-white'
          title={actions.createItemMutation.isPending ? 'CREANDO...' : 'CREAR ITEM'}
          disabled={actions.createItemMutation.isPending}
        />
      </>
    }
  >
    <div className='mx-auto w-full max-w-3xl'>
      <div className='mb-4 flex items-start justify-between gap-4'>
        <div>
          <p className='text-[11px] font-semibold uppercase tracking-[0.14em] text-accent2'>
            Alta individual
          </p>
          <h3 className='mt-1 text-2xl font-semibold text-slate-950'>Crear nuevo item</h3>
          <p className='mt-1 text-sm text-slate-600'>
            Registra un nuevo producto, insumo o servicio sin salir del módulo de inventario.
          </p>
        </div>
      </div>

      <form
        id='inventory-create-item-form'
        className='space-y-3 rounded-2xl bg-white p-4 shadow-sm'
        onSubmit={actions.handleItemSubmit}
      >
        <InventoryItemFormFields form={state.itemForm} onChange={state.setItemForm} />
      </form>
    </div>
  </ResizableModal>
)

export default CreateItemModal
